import Stop from './Stop.styled';

export default Stop;
